import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import auth from "../../common/auth";
import api_comm from "../../common/lib";

export const getNavLinks = createAsyncThunk(
	"nav/Links",
	async (arg, { getState }) => {
		const state = getState();

		try {
			// Get items.
			if (state.Login.IsLoggedIn) {
				let NavLinks = await api_comm(
					"get",
					"/site/api/v2/navigation",
					{},
					state.Login.Auth.session_token
				);

				return NavLinks.data;
			} else {
				let NavLinks = await api_comm(
					"get",
					"/site/api/v2/navigation",
					{},
					auth().getSessionToken()
				);

				return NavLinks.data;
			}
		} catch (e) {
			if (e.data.error) {
				console.log(e.data.data.error);
			}
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	NavLinks: [],
	loading: true,
};

export const NavLinksSlice = createSlice({
	name: "NavLinks",
	initialState,
	reducers: {
		setNavLinks: (state, action) => {
			state.NavLinks = action.payload;
		},
	},
	extraReducers: {
		[getNavLinks.pending]: (state, action) => {
			state.loading = true;
		},
		[getNavLinks.fulfilled]: (state, action) => {
			// console.log("action.payload ==> ", action.payload);
			state.NavLinks = action.payload;
			state.loading = false;
		},
		[getNavLinks.rejected]: (state, action) => {
			state.error = action.payload;
			state.loading = false;
			state.NavLinks = [];
		},
	},
});

export const { setNavLinks } = NavLinksSlice.actions;

export default NavLinksSlice.reducer;
